const categories = require('../store/modules/product_categroies.json')
const products = require('../store/modules/products.json')

const localizedFields = [
  'name',
  'kind',
  'pricing',
  'specification',
  'feature',
  'suitable',
  'recommendations',
  'ingredients'
]

function localize(field, locale) {
  return field[locale] || field.tw
}

function getProducts(locale) {
  return products.map((product, index) => {
    const localizedProduct = {
      id: String(index),
      imageUrl: product.imageUrl,
      category: product.category,
      attachment: product.attachment
    }

    for (const field of localizedFields) {
      localizedProduct[field] = localize(product[field], locale)
    }

    return localizedProduct
  })
}

function getProduct(id, locale) {
  return getProducts(locale).find(product => product.id === String(id))
}

function getCategories(locale) {
  return categories.map(category => ({
    id: category.name,
    name: localize(category.lang, locale)
  }))
}

function getMessages() {
  return Object.fromEntries(
    ['tw', 'cn'].map(locale => [
      locale,
      {
        products: Object.fromEntries(
          getProducts(locale).map(product => [
            product.id,
            Object.fromEntries(
              localizedFields.map(field => [field, product[field]])
            )
          ])
        ),
        products_categories: Object.fromEntries(
          getCategories(locale).map(category => [
            category.id,
            category.name
          ])
        )
      }
    ])
  )
}

function mergeMessages(baseMessages) {
  const catalogMessages = getMessages()
  const locales = new Set([
    ...Object.keys(baseMessages),
    ...Object.keys(catalogMessages)
  ])

  return Object.fromEntries(
    Array.from(locales).map(locale => {
      const base = baseMessages[locale] || {}
      const catalog = catalogMessages[locale]

      if (!catalog) {
        return [locale, { ...base }]
      }

      return [
        locale,
        {
          ...base,
          products: catalog.products,
          products_categories: {
            ...(base.products_categories || {}),
            ...catalog.products_categories
          }
        }
      ]
    })
  )
}

module.exports = {
  getCategories,
  getMessages,
  getProduct,
  getProducts,
  mergeMessages
}
